export default __webpack_public_path__ + "static/media/hero-1.4ef78f89.jpg";